import { formatFileSize } from './format';

/** Client-side convenience checks only - the server enforces file type and size. Returns a message or null. */
export function validateImportFile(file: File, maxUploadBytes: number, acceptedFileTypes: string[]): string | null {
  const name = file.name.toLowerCase();
  if (!acceptedFileTypes.some((type) => name.endsWith(type))) {
    return acceptedFileTypes.length === 1 && acceptedFileTypes[0] === '.zip'
      ? 'Only a .zip export can be imported. Choose the .zip package exported from your payroll system.'
      : `Only ${describeTypes(acceptedFileTypes)} can be imported with this choice. Choose a different file.`;
  }
  if (maxUploadBytes > 0 && file.size > maxUploadBytes) {
    return `That file is larger than the ${formatFileSize(maxUploadBytes)} limit.`;
  }
  return null;
}

/** The original Escochex package check (a .zip only). */
export function validateZipFile(file: File, maxUploadBytes: number): string | null {
  return validateImportFile(file, maxUploadBytes, ['.zip']);
}

/** ".xlsx" -> "an .xlsx workbook"; [".xlsx", ".csv"] -> "an .xlsx workbook or a .csv file". */
export function describeTypes(types: string[]): string {
  const words = types.map((t) => (t === '.xlsx' ? 'an .xlsx workbook' : t === '.csv' ? 'a .csv file' : t === '.zip' ? 'a .zip package' : `a ${t} file`));
  return words.join(' or ');
}

/** The words used around the file picker for a provider's accepted file types. */
export function uploadLabels(types: string[]): { input: string; button: string; drop: string } {
  if (types.length === 1 && types[0] === '.zip') {
    return { input: 'Payroll history package (.zip)', button: 'Choose .zip file', drop: 'Drag and drop your .zip package here, or' };
  }
  if (types.length === 1) {
    return { input: `Payroll history file (${types[0]})`, button: `Choose ${types[0]} file`, drop: `Drag and drop your ${types[0]} file here, or` };
  }
  return {
    input: `Payroll history file (${types.join(' or ')})`, button: 'Choose spreadsheet or CSV file',
    drop: 'Drag and drop your spreadsheet or CSV file here, or',
  };
}
